import React, { useEffect, useState } from "react";
import axios from "../../AxiosInstance";
import { Table } from "antd";
import Sidebar from "../../components/Sidebar";

const AccountPerfernce = () => {
  const [users, setUsers] = useState([]); // State to store users

  // Fetch users with newsletter preferences selected
  const fetchUsersWithPreferences = async () => {
    try {
      const storedAuth = JSON.parse(localStorage.getItem("auth"));
      const token = storedAuth?.token;

      if (!token) {
        console.error("❌ Token missing in localStorage");
        return;
      }

      const res = await axios.get("api/v1/admin/newsletter-emails", {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Now using res.data.users since backend is sending full user objects
      setUsers(res.data.users); // Set the full user data, not just emails
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsersWithPreferences(); // Fetch user data when admin token is available
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "name", // Assuming name is directly available
      key: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email", // Assuming email is directly available
      key: "email",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Ambassador",
      dataIndex: "isAmbassador", // Assuming isAmbassador is a boolean
      render: (text) => <span>{text ? "Yes" : "No"}</span>,
    },
    {
      title: "Newsletter Preferences",
      render: (text, record) => (
        <>
          {record.newsletterPreferences?.checkbox1 && (
            <span>Latest trending books, </span>
          )}
          {record.newsletterPreferences?.checkbox2 && (
            <span>Upcoming month’s new books, </span>
          )}
          {record.newsletterPreferences?.checkbox3 && (
            <span>Books, Authors and events, </span>
          )}
          {record.newsletterPreferences?.checkbox4 && (
            <span>New Ofellio features</span>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <div className="d-md-flex gap-5 ">
        <Sidebar />
        <div className="container prrrt" style={{ height: "100vh" }}>
          <h2 className="text-center mt-4">NewsLetters List</h2>
          <div className=".ant-table-container mb-5">
            {users.length > 0 ? (
              <Table
                columns={columns}
                dataSource={users}
                pagination={{ pageSize: 6 }}
                rowKey="email" // Ensure each row has a unique key (using email as the key)
                scroll={{ x: "560px" }} // 👈 Yeh line add karni hai
              />
            ) : (
              <p className="text-center">Loading newsletter list...</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountPerfernce;
